import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    padding: theme.spacings.md,
  },
  bodyText: {
    fontSize: theme.fontSizes.xl,
  },
  linkText: {
    fontWeight: '700',
    color: theme.colors.link,
  },
});
